var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, html, styleMap, nothing } from '@sick-davinci/ce-decorators';
import { style } from './NumericChart.style';
import { TextChartBase } from '../text-chart/TextChartBase.js';
import { NumberFormatter } from '../_utils/NumberFormatter.js';
/**
 * Displays a formated number with a unit in different sizes.
 * If space isn't sufficient, the size is always reduced.
 * If size is not set the text es sized with the available size (between xmall and xlarge)
 *
 * @example
 * ```
 * <davinci-element-container heading="NumericChart" style="width: 300px; height: 300px">
 *   <davinci-numeric-chart value='100' unit='meter'></davinci-numeric-chart>
 * </davinci-element-container>
 * ```
 */

export let NumericChart = (_dec = Component({
  tag: 'davinci-numeric-chart',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Number), _dec(_class = (_class2 = class NumericChart extends TextChartBase {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);

    _initializerDefineProperty(this, "unit", _descriptor2, this);

    _initializerDefineProperty(this, "suffix", _descriptor3, this);

    _initializerDefineProperty(this, "prefix", _descriptor4, this);

    _defineProperty(this, "_valueFormatter", NumberFormatter.CREATE_DEFAULT());
  }

  /**
   * The number of decimal places to use. Possible values are from 0 to 10.
   *
   * If undefined no fixed number of decimal places will be used.
   *
   * @default undefined
   */
  set decimalPlaces(dp) {
    this._decimalPlaces = dp;
    this._valueFormatter = new NumberFormatter(false, dp);
  }

  get decimalPlaces() {
    return this._decimalPlaces;
  }

  /**
   * See base class
   */
  render() {
    if (typeof this.value === 'number') {
      const val = this._valueFormatter.format(this.value);

      const txt = this.prefix + val + this.suffix;

      const size = this._getFontSize(txt, this.unit);

      return html`
      <div id='container' style=${this.textColor ? 'color: ' + this.textColor : ''}>
        <div id='valtext'>
          <div class='value' style=${styleMap({
        fontSize: this._fontSize.get(size).value,
        lineHeight: this._fontSize.get(size).value
      })}>${txt}</div>
          <div style=${styleMap({
        fontSize: this._fontSize.get(size).unit,
        lineHeight: this._fontSize.get(size).unit
      })} class='unit'>${this.unit}</div>
        </div>
        ${this._renderSubtext(size)}
      </div>
      `;
    } else {
      return html`${nothing}`;
    }
  }

  _getFontSize(valText, unitText) {
    let size = this.size;

    let width = this._totalTextWidth(size, valText, unitText);

    let height = this._totalTextHeight(size); // shrink if space isn't sufficient


    while ((width > this.clientWidth || height > this.clientHeight) && size != 'xsmall') {
      size = TextChartBase.SIZE_ORDER[TextChartBase.SIZE_ORDER.indexOf(size) - 1];
      width = this._totalTextWidth(size, valText, unitText);
      height = this._totalTextHeight(size);
    }

    return size;
  }

  _totalTextWidth(size, valText, unitText) {
    return this._textWidth(valText, this._fontSize.get(size).value) + this._textWidth(unitText, this._fontSize.get(size).unit);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "suffix", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "prefix", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "decimalPlaces", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "decimalPlaces"), _class2.prototype)), _class2)) || _class);
